import axios from 'axios'

export default {
  install(Vue){
    Vue.prototype.$AlarmasService = {
      test(){
        //console.log('Funcionando');
      },
      /* async authorize(user,password){   
        var obj = {Username:user,Password:password,RememberMe:false}
        var response = await axios.post('api/auth/authorize/',obj);
        //console.log(response);

        if(response.data.Authenticated){
            store.dispatch("saveToken", {token: response.data.Token, expire: response.data.TokenExpires})
            store.dispatch("saveRefreshTokenEveryNMin",response.data.RefreshTokenEveryNMin*60*1000);
        }else{
            //console.log('Usuario o contraseña invalidos');
        } 
        return await response.data
      },
      async licencia(){
        var obj = {Username:'LoginXsite',Password:'ValidarLicenciaAbc123$%'}
        var response = await axios.post('api/auth/authorize/',obj);
        return await response.data;
      },
      async info(){
        var response = await axios.get('api/ubicacion/sysinfo');
        return await response.data;
      }, */
      async getAlarmas(){   
        var response = await axios.get('api/ubicacion/sysinfo');
        //console.log(response);
        return response.data;
      }
    }
  }
}